import React from 'react';

export type RoutingData = {
  message: string;
  href: string;
};

type PageContextType = {
  parentPageName?: string;
  routingData?: RoutingData;
};

type PageContextProps = {
  children: React.ReactElement;
  value: PageContextType;
};

const Page = React.createContext({});

export const PageContext: React.FC<PageContextProps> = ({ children, value }) => (
  <Page.Provider value={value}>{children}</Page.Provider>
);

export const usePageContext = (): PageContextType => React.useContext(Page);
